import Billing from "@/components/main/user/billing/component.vue";
import Pay from "@/components/main/user/pay/component.vue";
import getSymbolFromCurrency from "currency-symbol-map";
import Confirm from "@/components/main/Confirm.vue";

import _ from "lodash";

export default {
  name: "",
  components: {
    Billing,
    Pay,
    Confirm
  },
  props: [],
  data() {
    return {
      selectedItem: null,
      confirmVisible: false,
      stripe: null,
      items: [],
      subs: [],
      firstLoadDone: false,
      nonceToken: null,
      billing: null,
      publicKey: null
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(
        this.items.filter(x => x.active),
        "amount"
      );
    }
  },

  async created() {
    this.publicKey = await this.GetPublicKey();
    await this.GetBilling();
    await this.GetItems();
    await this.GetSubs();

    this.firstLoadDone = true;
  },
  async mounted() {},

  methods: {
    GetAmount(amount) {
      return parseFloat(amount.slice(0, -2) + "." + amount.slice(-2));
    },

    GetSymbol(currency) {
      return getSymbolFromCurrency(currency);
    },

    async RefreshBilling() {
      await this.GetBilling();
    },
    async Subscribe(plan, paymentMethod) {
      this.$set(plan, "isLoading", true);

      try {
        let res = await this.$helpers.PostApi("plan/subscribe", {
          paymentMethod: paymentMethod,
          planId: plan.id
        });

        if (res.clientToken) {
          await this.LoadStripeScript();
          let done = await this.ConfirmPayment(
            res.clientToken,
            paymentMethod.id
          );
          if (done) {
            await this.UpdateSubscription(res.subscriptionId);
            await this.SubCompleted(
              plan,
              "Subscription has been added. Thank you!",
              "success"
            );
          } else {
            await this.SubCompleted(
              plan,
              "The subscription has been added but is not active until you complete the payment.",
              "warning"
            );
          }
        } else {
          await this.SubCompleted(
            plan,
            "Subscription has been added. Thank you!",
            "success"
          );
        }

        this.$set(plan, "isLoading", false);
      } catch (err) {
        console.log(err);
        this.$set(plan, "isLoading", false);

        this.$helpers.ShowStatus(
          "An error occured, please try again later.",
          0,
          "warning"
        );
      }
    },

    async SubCompleted(plan, notification, color) {
      await this.GetSubs();
      this.$set(plan, "isLoading", false);
      this.$helpers.ShowStatus(notification, 0, color);
      this.$emit("subscriptionChanged");
    },

    async GetPublicKey() {
      return await this.$helpers.PostApi("get/stripeKey");
    },

    async GetSession(planId) {
      return await this.$helpers.PostApi("get/session", {
        planId: planId
      });
    },

    async GetItems() {
      const plans = await this.$helpers.PostApi("get/plans");

      this.items = plans.filter(x =>
        x.product.name.toLowerCase().includes("computers")
      );
    },

    async CancelSub(item) {
      this.$set(item, "isLoading", true);

      try {
        let result = await this.$helpers.PostApi("subscription/cancel", {
          subscriptionId: item.subscription.uid,
          planId: item.plan.id
        });

        item.subscription.status = result[0].status;
        item.subscription.paidThroughDate = result[0].paidThroughDate;
        this.$set(item, "isLoading", false);
        this.$emit("subscriptionChanged");

        this.$helpers.ShowStatus("Done", 3000, "success");
      } catch {
        this.$set(item, "isLoading", false);
        this.$helpers.ShowStatus(
          "An error occured, please try again later.",
          5000,
          "warning"
        );
      }
    },

    async GetBilling() {
      let result = await this.$helpers.PostApi("get/userBilling");
      this.billing = result[0];
    },

    async GetSubs() {
      let res = await this.$helpers.PostApi("get/subscriptions");
      res = _.orderBy(res, ["subscription.created"], "desc");
      this.subs = res
        .map(x => {
          let plan = this.items.find(y => y.id === x.plan.uid);
          if (plan) {
            x.plan = plan;
            return x;
          }
        })
        .filter(x => x);
    },

    LoadStripeScript() {
      return new Promise((resolve, reject) => {
        let script = document.getElementById("stripe");

        if (!script) {
          script = document.createElement("script");
          script.setAttribute("src", "https://js.stripe.com/v3/");
          script.setAttribute("id", "stripe");
          document.head.appendChild(script);
          script.onload = async () => {
            this.InitStripe();
            resolve();
          };
        } else {
          this.InitStripe();
          resolve();
        }
      });
    },

    async InitStripe() {
      if (this.publicKey) {
        this.stripe = window.Stripe(this.publicKey);
      }
    },

    async ConfirmPayment(clientToken, paymentMethodId, offSession) {
      try {
        if (this.stripe) {
          let result;
          if (!offSession) {
            result = await this.stripe.confirmCardPayment(clientToken, {
              payment_method: paymentMethodId
            });
          } else {
            result = await this.stripe.confirmCardPayment(clientToken, {
              payment_method: paymentMethodId,
              setup_future_usage: "off_session"
            });
          }

          if (result.error) {
            console.log(result.error);
            this.$helpers.ShowStatus(result.error.message, 0, "warning");
          } else {
            return true;
          }
        } else {
          console.log("stripe is not inited");
        }
      } catch (err) {}

      return false;
    },

    async UpdateSubscription(subscriptionId) {
      let result = await this.$helpers.PostApi("subscription/update", {
        subscriptionId: subscriptionId
      });

      let newItem = result[0];

      if (newItem) {
        let item = this.subs.find(x => x.plan.id === newItem.plan.uid);
        if (item) {
          item.subscription = newItem.subscription;
        }
      }
    },

    async CompletePayment(item) {
      this.$set(item, "isLoading", true);

      try {
        let res = await this.$helpers.PostApi("subscription/complete", {
          subscriptionId: item.subscription.uid
        });

        if (res) {
          await this.LoadStripeScript();
          let done = await this.ConfirmPayment(
            res.clientToken,
            res.paymentMethodId,
            true
          );

          if (done) {
            await this.UpdateSubscription(item.subscription.uid);
            await this.GetSubs();
          }
        }

        if (item) {
          this.$set(item, "isLoading", false);
        }
      } catch (err) {
        console.log(err);
        this.$set(item, "isLoading", false);

        this.$helpers.ShowStatus(
          "An error occured, please try again later.",
          0,
          "warning"
        );
      }
    },

    async UpdateSubscriptionPaymentMethod(subscriptionId, paymentMethodId) {
      console.log(subscriptionId, paymentMethodId);
      let result = await this.$helpers.PostApi(
        "subscription/update/paymentmethod",
        {
          subscriptionId: subscriptionId,
          paymentMethodId: paymentMethodId
        }
      );

      this.$helpers.ShowStatus("Payment method was saved.", 3000);
    }
  }
};
